module.exports = __webpack_public_path__ + "static/media/Kecleon_gaussian2.3cc4d132.png";